// Claude Design (8) CMP Dashboard.dc.html:11081-11106: a failed Create or
// Preview on an invoice page scrolls to the first field with an error and
// focuses it. Fields mark errors with data-invoice-field-error="true"
// (Create Invoice) or MUI's aria-invalid (event invoice pages), in DOM order.
const invalidFieldSelector =
  '[data-invoice-field-error="true"], [aria-invalid="true"]';
const focusableSelector =
  'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const scrollToFirstInvalidField = (root: ParentNode = document) => {
  // Wait one tick so the error states from the failed attempt have rendered.
  window.setTimeout(() => {
    const invalid = root.querySelector<HTMLElement>(invalidFieldSelector);
    if (!invalid) return;
    invalid.scrollIntoView({ behavior: "smooth", block: "center" });
    const focusTarget = invalid.matches(focusableSelector)
      ? invalid
      : invalid.querySelector<HTMLElement>(focusableSelector);
    focusTarget?.focus({ preventScroll: true });
  }, 60);
};
